import { Injectable } from '@angular/core';
import { AppSettings } from 'app/app.settings';
import { BehaviorSubject, Subject } from 'rxjs';
import { CommonRequestService, PagingParam } from './common-request.service';
import { UserService } from './user.service';

import Feature from 'ol/Feature';
import WKT from 'ol/format/WKT';
import {
	LineString,
	MultiLineString,
	MultiPoint,
	MultiPolygon,
	Point,
	Polygon,
} from 'ol/geom';
import LinearRing from 'ol/geom/LinearRing';

import { v1 as uuid } from 'uuid';

import { CommonMapService } from './common-map.service';
import { AttrIndexService } from './attr-index.service';
import { ModelMenuItemKey } from './main-data.service';
import { CommonTableService } from './common-table.service';
import { Gfo, GfoService } from './gfo.service';
import { LayerService } from './layer.service';
import { AppinfoService } from './appinfo.service';
import { JstsService } from './jsts.service';
import { SocketLogs, SocketService } from './socket.service';

export interface FishboneSpikeData {
	addrWkt: string;
	addrGeocodeWkt: string;
	addrUuid;
	fishboneId;
	attrs;  // FishboneSpikeDataFeatAttr;
}

export interface FishboneRoad {
	wkt: string;
	attrs: any; // FishboneRoadsAttr;
	uuid: string;
}
export interface FishboneRoads {
	[roadUuid: string]: FishboneRoad;
};

export type FishboneCardType = 'addr' | 'centerline';
export type FishboneCode = 'FS1' | 'FS2' | 'FS3' | 'FS4' | 'FS5' | 'FS6' | 'FS7' | 'FS8' | 'FS9' | 'FSA' | 'FSB' | 'FS1L' | 'FS2L' | 'FS3L' | 'FS4L' | 'FS5L' | 'FS6L' | 'FS7L' | 'FS8L' | 'FS9L';

export interface AddressFishboneInfo {
	legacy?: {
		cd: FishboneCode;
		note: string;
		geocode?: string; // wkt Point or MultiPoint
		rcl?: string[]; // list of rcl globalId
	}
	nena?: {
		cd: FishboneCode;
		note: string;
		geocode?: string; // wkt Point or MultiPoint
		rcl?: string[]; // list of rcl globalId
	}
}
@Injectable({
  providedIn: 'root'
})
export class FishboneService {

	fishboneControlBS: BehaviorSubject<{isOn?: boolean;}> = new BehaviorSubject({
		isOn: true
	})
	// Fishbone messages by processId
	fbLogs: BehaviorSubject<SocketLogs> = new BehaviorSubject({});
	onFbFinish: Subject<{ isError: boolean;}> = new Subject();





	interactiveFishboneSubject: Subject<'start' | 'stop'> = new Subject();
	fishboneRoads: FishboneRoads = {};

	constructor(
		private appinfoService: AppinfoService,
		private attrIndexService: AttrIndexService,
		private cMapService: CommonMapService,
		private requestService: CommonRequestService,
		private tableService: CommonTableService,
		private gfoService: GfoService,
		private jstsService: JstsService,
		private layerService: LayerService,
		private socketService: SocketService,
		private userService: UserService
	) { }

	createFishboneSpikes(addrCoord: number[], wktGeocode: string): {
		spikeFeats: Feature[];
		geocodeFeat: Feature<Point | MultiPoint>;
	} | null {
		if (!addrCoord || !wktGeocode || !wktGeocode.length) { return null; }
		const wktFormat = new WKT;
		const addrGeocodeGeom = (<Point | MultiPoint>wktFormat.readGeometry(wktGeocode));
		let addrGeocodeCoord: any[] = addrGeocodeGeom.getCoordinates();
		const spikeFeats = [];
		if (addrGeocodeGeom.getType() === 'Point') { // addrGeocodeCoord can be Point or MultiPoint // Transform the coords to multipoint for further processing
			addrGeocodeCoord = [addrGeocodeCoord];
		}
		// Create a linestring for each geocode point
		addrGeocodeCoord.map(geocodeCoord => {
			const geom = new LineString([addrCoord, geocodeCoord]);
			const feat = new Feature({
				geometry: geom
			});
			spikeFeats.push(feat);

		});
		const geocodeFeat = new Feature({
			geometry: addrGeocodeGeom
		});
		return {
			spikeFeats: spikeFeats,
			geocodeFeat: geocodeFeat
		};
	}
	analyzeFishbone() {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/analyzeFishbone';
			//
			const tempProcessId = uuid();
			this.socketService.onInitProcess.next({
				tempId: tempProcessId,
				processType: 'AnalyzeFishbone'
			});
			//
			this.requestService.requestPost(url, {
				userSubscriptionId: this.userService.getUserInfo().userSubId,
				customerId: this.userService.customerInfo.id,
				userId: this.userService.getUserInfo().userId,
				sessionId: this.appinfoService.getSessionUuid()
			}, (rsp: any) => {
				console.log(rsp);
				const processesById = this.fbLogs.getValue();
				const processId = rsp.data.content;
				this.socketService.onInitProcess.next({
					tempId: tempProcessId,
					processId: processId,
					processType: 'AnalyzeFishbone'
				});
				const process = this.socketService.registerProcessById(rsp.data.content, processesById);
				this.fbLogs.next(processesById);
				resolve(rsp);
			}, err => reject(err));
		});
	}
	// drawFishboneByInfo(olLayer, fbOlLayer, modelKey: ModelMenuItemKey) {
	// 	const features = olLayer.getSource().getFeatures();
	// 	features.forEach(f => {
	// 		const fb: AddressFishboneInfo = f.getProperties()[this.attrIndexService.addrFishboneCol];
	// 		if (!fb) {
	// 			return;
	// 		}
	// 		const fbByModel = modelKey === 'L' ? fb.legacy : fb.nena;
	// 		if (!fbByModel) {
	// 			return;
	// 		}
	// 		// Update address prop
	// 		const fbCode = fbByModel.cd;
	// 		const props = {};
	// 		props[this.attrIndexService.fishboneCodeKey] = fbCode;
	// 		f.setProperties(props);
	// 		//
	// 		const addrCoord = f.getGeometry().getCoordinates();
	// 		const feats = this.createFishboneSpikes(addrCoord, fbByModel.geocode);
	// 		if (feats) {
	// 			fbOlLayer.getSource().addFeatures(feats.spikeFeats);
	// 			fbOlLayer.getSource().addFeatures(feats.geocodeFeat);
	// 		}
	// 	});
	// }





























	getQrFishboneByAttr(customerId, qaCodes?: string[], gfo?: Gfo, paging?: PagingParam, sortColumns?: string[]) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/qrFishboneByAttr';
			const params: any = {
				customerId: customerId,
			};
			if (qaCodes) {
				params.qaCodes = JSON.stringify(qaCodes);
			}
			if (gfo) {
				params.gfo = JSON.stringify(gfo);
			}
			if (!paging) {
				paging = {
					pageSize: this.tableService.defaultTableConfig.pageSize
				};
			} else if (!paging.pageSize) {
				paging.pageSize = this.tableService.defaultTableConfig.pageSize;
			}
			if (sortColumns && sortColumns.length) {
				params.sortColumns = JSON.stringify(sortColumns);
			}
			this.requestService.setParamsPaging(params, paging);
			this.requestService.requestGet(url, {
				params: params
			}, (rsp) => {
				resolve(rsp);
			}, err => reject(err));
		});
	}
	getQrFishboneByMap(customerId, bbox: number[], qaCodes?: string[], gfo?: Gfo, sortColumns?: string[]) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/qrFishboneByMap';
			const params: any = {
				customerId: customerId,
				bbox: JSON.stringify(bbox)
			};
			if (qaCodes) {
				params.qaCodes = JSON.stringify(qaCodes);
			}
			if (gfo) {
				params.gfo = JSON.stringify(gfo);
			}
			if (sortColumns && sortColumns.length) {
				params.sortColumns = JSON.stringify(sortColumns);
			}
			this.requestService.requestGet(url, {
				params: params
			}, (rsp) => {
				if (rsp && rsp.data) {
					// Sort so that FSA/FSB will draw before FS1/FS3
					rsp.data.sort((a, b) => {
						if (!b.qa_notes || !b.qa_notes.cd) {
							return -1
						} else if (!a.qa_note || !a.qa_notes.cd) {
							return 1;
						} else {
							if (a.qa_notes.cd < b.qa_notes.cd) {
								return 1
							} else if (a.qa_notes.cd > b.qa_notes.cd) {
								return -1;
							} else {
								return 0;
							}
						}
					})
				}
				resolve(rsp);
			}, err => reject(err));
		});
	}
	getQcInterLayerReportByAttrQuery(customerId, reportType: string, qaCodes?: string[], gfo?: Gfo) {
		return new Promise<string>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/qcInterLayerReportByAttrQuery';
			const params: any = {
				customerId: customerId,
				reportType: reportType
			};
			if (qaCodes) {
				params.qaCodes = JSON.stringify(qaCodes);
			}
			if (gfo) {
				params.gfo = JSON.stringify(gfo);
			}
			this.requestService.requestGet(url, {
				params: params
			}, (rsp) => {
				resolve(rsp.data.sql);
			}, err => reject(err));
		});
	}
	buildFishbone() {
		// TODO


		// const layer = this.layerService.layerListBS.getValue().layers.find(l => l.category && l.category.code === this.attrIndexService.cateCodeAddress);
		// if (layer && layer.id) {
		// 	this.qcLayers(layer.id, 'fishbone');
		// } else {
		// 	this.toastr.info('Address layer not found');
		// }
	}
	getFishboneInteractive(rcId, model?: ModelMenuItemKey) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/qrInterlayerFishboneInteractive';
			const params: any = {
				customerId: this.userService.customerInfo.id,
				rclGrdId: rcId
			}
			if (model) {
				params.model = model;
			}
			this.requestService.requestGet(url, {
				params: params
			}, rsp => {
				console.log(rsp);
				resolve(rsp);
			}, err => reject(err))
		});
	}

	getFishboneId(rec) {
		if (rec[this.attrIndexService.isFishboneAddrKey]) {
			return rec[this.attrIndexService.interlayerGlobalId1];
			// return rec[this.attrIndexService.addrUuidCol];
		} else if (rec[this.attrIndexService.isFishboneRoadKey]) {
			return rec[this.attrIndexService.rcUuidCol];
		} else {
			console.log('TODO: ??????')
			// TODO:
			// return rec[this.addrUuidCol] + '-' + rec[this.qaNotesColName].cd;
		}
	}

	getFeaturesFromFishboneData(data: any[], isGetRoutes?: boolean) {
		let spikeFeatures = [];
		let addressFeatures = [];
		const routes = {
			layerId: null,
			uuids: []
		};
		data.forEach(d => {
			const wkt = d[this.attrIndexService.addrWktCol];
			const geocodeWkt = d[this.attrIndexService.interLayerWktCol] ? d[this.attrIndexService.interLayerWktCol][0] : null;
			const fishboneId = this.getFishboneId(d);
			const addrUuid = d[this.attrIndexService.interlayerGlobalId1]; // d[this.attrIndexService.addrUuidCol];
			// const rcUuids = d[this.rcUuidCol2];
			const feats = this.createAddressAndSpikeFeatures({
				addrWkt: wkt,
				addrGeocodeWkt: geocodeWkt,
				fishboneId: fishboneId,
				addrUuid: addrUuid,
				attrs: d,
				// attrs: {
				// 	addNum: d[this.addrNumCol],
				// 	fullSt: d[this.fullStCol],
				// 		// roads: rcUuids ? rcUuids.map(recId => {
				// 		// 	return {
				// 		// 		rcRecId: recId
				// 		// 	}
				// 		// }) : [],
				// 	fishboneQaCodes: d[this.qaNotesColName] ? d[this.qaNotesColName] : {}
				// }
			});
			if (feats.spikeFeatures) {
				spikeFeatures = spikeFeatures.concat(feats.spikeFeatures);
			}
			if (feats.addressFeature) {
				addressFeatures.push(feats.addressFeature);
			}
			if (isGetRoutes) {
				// route layer
				const layerId = d[this.attrIndexService.fishboneRcLayerIdCol];
				const roadIds = d[this.attrIndexService.rcUuidCol2];
				if (layerId && roadIds) {
					routes.layerId = layerId;
					roadIds.forEach(i => {
						if (routes.uuids.indexOf(i) === -1) {
							routes.uuids.push(i);
						}
					});
				}
			}
		});
		return {
			spikeFeatures: spikeFeatures,
			addressFeatures: addressFeatures,
			routes: routes
		}
	}

	async calcFishboneRoads(data: { layerId: number; uuids: any[]; }, overrideFishboneRoads?: boolean) {
		const rcUuidCol = this.attrIndexService.rcUuidCol;
		const fishboneRoads: FishboneRoads = {};
		if (data.layerId && data.uuids) {
			const requestIds = [];
			data.uuids.forEach(rcUuid => {
				if (!this.fishboneRoads[rcUuid]) {
					requestIds.push(rcUuid);
				} else {
					fishboneRoads[rcUuid] = this.fishboneRoads[rcUuid];
				}
			});
			if (requestIds.length) {
				const filter = this.gfoService.getFilter(rcUuidCol, this.appinfoService.filterOperators.in.name, requestIds);
				const gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
				const geomRsps = await this.layerService.getLayerGeometry(data.layerId, null, gfo);
				const contentRsps = await this.layerService.getLayerContents(data.layerId, gfo);
				geomRsps.data.forEach(geomRsp => {
					const uuid = geomRsp[rcUuidCol];
					const contentRsp = contentRsps.data.find(i => i[rcUuidCol] === uuid);
					if (contentRsp) {
						fishboneRoads[uuid] = {
							wkt: geomRsp[this.attrIndexService.rcGeomCol],
							attrs: contentRsp,
							uuid: uuid
						};
						this.fishboneRoads[uuid] = fishboneRoads[uuid];
					}
				});
			}
			// data.uuids.forEach(rcUuid => {
			// 	if (!this.fishboneService.fishboneRoads[rcUuid]) {
			// 		const geomRequest = this.layerService.getLayerGeometry(data.layerId, rcUuid);
			// 		const filter = this.gfoService.getFilter(rcUuidCol, this.appinfoService.filterOperators.eq.name, rcUuid);
			// 		const gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
			// 		const contentRequest = this.layerService.getLayerContents(data.layerId, this.selectedCustomerId, gfo);
			// 		promises.push(geomRequest);
			// 		promises.push(contentRequest);
			// 	} else {
			// 		fishboneRoads[rcUuid] = this.fishboneService.fishboneRoads[rcUuid];
			// 	}
			// });
			// await Promise.all(promises).then((rsps) => {
			// 	for(let i = 0; i < rsps.length - 1; i += 2) {
			// 		const rcGeomRsp = rsps[i];
			// 		const rcContentRsp = rsps[i + 1];
			// 		if (rcGeomRsp && rcGeomRsp.data && rcGeomRsp.data.length && rcContentRsp && rcContentRsp.data) {
			// 			const geom = rcGeomRsp.data[0];
			// 			const content = rcContentRsp.data[0];
			// 			const uuid = content[rcUuidCol];
			// 			const fromAddrLeft = content[this.rcFromAddrLeftCol];
			// 			const fromAddrRight = content[this.rcFromAddrRightCol];
			// 			const toAddrLeft = content[this.rcToAddrLeftCol];
			// 			const toAddrRight = content[this.rcToAddrRightCol];
			// 			const fullStName = this.getFullStNameFromRcData(content);
			// 			const placeName = this.getPlaceNameFromRcRcData(content);
			// 			fishboneRoads[uuid] = {
			// 				wkt: geom[this.rcGeomCol],
			// 				attrs: content,
			// 				// attrs: {
			// 				// 	fromAddrLeft: fromAddrLeft,
			// 				// 	fromAddrRight: fromAddrRight,
			// 				// 	toAddrLeft: toAddrLeft,
			// 				// 	toAddrRight: toAddrRight,
			// 				// 	fullSt: fullStName,
			// 				// 	placeName: placeName
			// 				// 	// rcRecId: content[rcUuidCol]
			// 				// },
			// 				uuid: uuid
			// 			};
			// 			this.fishboneService.fishboneRoads[uuid] = fishboneRoads[uuid];
			// 		}
			// 	}
			// });
		}
		if (overrideFishboneRoads) {
			this.fishboneRoads = fishboneRoads;
		}
		return fishboneRoads;
	}
	drawFishboneRoads(layer, fishboneRoads: FishboneRoads) {
		const features = [];
		for (const uuid of Object.keys(fishboneRoads)) {
			const route = fishboneRoads[uuid];
			const wkt = route.wkt;
			if (!wkt) { continue; }
			const feat = this.cMapService.createFeatureByWkt(wkt);
			const props = {};
			props[this.attrIndexService.attrKey] = route.attrs;
			props[this.attrIndexService.isFishboneRoadKey] = true;
			// props[this.fishboneCenterlineUuidKey] = route.uuid;
			feat.setProperties(props);
			feat.setId(uuid);
			features.push(feat);
		}
		layer.getSource().addFeatures(features);
		return features;
	}

	// Create Address feature AND Spike features (if any)
	createAddressAndSpikeFeatures(d: FishboneSpikeData) {
		let addressFeature;
		let spikeFeatures;
		if (d.addrGeocodeWkt && d.addrWkt) {

			spikeFeatures = this.createFishspikeFeatures(d.addrWkt, d.addrGeocodeWkt); // It's important the wkt goes before geocodeWkt, the first point will be marked in the style
			// Check long bone
			spikeFeatures.forEach(feat => this.checkLongBone(feat));
		}
		if (d.addrWkt) {
			addressFeature = this.cMapService.createFeatureByWkt(d.addrWkt);
			const props: any = {};
			props[this.attrIndexService.isFishboneAddrKey] = true;
			props[this.attrIndexService.attrKey] = d.attrs;
			props[this.attrIndexService.fishboneIdKey] = d.fishboneId;
			props[this.attrIndexService.fishboneAddrUuidKey] = d.addrUuid;
			addressFeature.setProperties(props);
			addressFeature.setId(d.addrUuid);
		}
		if (spikeFeatures) {
			// No need to set id for splikes
			// Set properties
			spikeFeatures.forEach(feat => {
				const props: any = {};
				props[this.attrIndexService.attrKey] = d.attrs;
				props[this.attrIndexService.fishboneIdKey] = d.fishboneId;
				props[this.attrIndexService.fishboneAddrUuidKey] = d.addrUuid;
				props[this.attrIndexService.isFishboneSpikeKey] = true;
				feat.setProperties(props);
			})
		}
		return {
			addressFeature: addressFeature,
			spikeFeatures: spikeFeatures
		};
	}
	// Fishbone spikes can be one or multiple features
	// Create spikes from fishbone's address geom
	private createFishspikeFeatures(wkt_addr, wkt_addr_geocode): Feature[] {
		if (!wkt_addr || !wkt_addr_geocode) { return; }
		const wktFormat = new WKT;
		const addrGeom = (<Point | MultiPoint>wktFormat.readGeometry(wkt_addr));
		const addrGeocodeGeom = (<Point | MultiPoint>wktFormat.readGeometry(wkt_addr_geocode));
		const addrCoord = addrGeom.getCoordinates();
		let addrGeocodeCoord: any[] = addrGeocodeGeom.getCoordinates();
		const features = [];
		if (addrGeocodeGeom.getType() === 'Point') { // addrGeocodeCoord can be Point or MultiPoint // Transform the coords to multipoint for further processing
			addrGeocodeCoord = [addrGeocodeCoord];
		}
		// Create a linestring for each geocode point
		addrGeocodeCoord.map(geocodeCoord => {
			const geom = new LineString([addrCoord, geocodeCoord]);
			const feat = new Feature({
				geometry: geom
			});
			features.push(feat);
		});
		return features;
	}
		
	private checkLongBone(feat) {
		const geomType = feat.getGeometry().getType();
		if (geomType === 'LineString') {
			const len = feat.getGeometry().getLength();
			if (len > 300) {
				const props: any = {};
				props[this.attrIndexService.isLongBoneKey] = true;
				feat.setProperties(props);
				return true;
			}
		}
	}
	checkCrossBones(feats: any[]) {
		// TODO: If data is too many, got error: Maximum call stack size exceeded error
		if (feats.length > 1000) {
			return;
		}

		const parser = this.jstsService.getJstsParser();
		const setCrossBoneAttr = (f) => {
			const props = {};
			props[this.attrIndexService.isCrossBoneKey] = true;
			f.setProperties(props);
		}
		let x = 0;
		const check = (arr: any[]) => {
			x++;
			if (arr.length <= 1 || x >= 10000) {
				return;
			}
			const geom0 = parser.read(arr[0].getGeometry());
			for (let j = 1; j <= arr.length - 1; j++) {
				const geomJ = parser.read(arr[j].getGeometry());
				const isIntersect = geom0.intersects(geomJ);
				if (isIntersect) {
					const intersection = this.jstsService.getJstsOverlayOp().intersection(geom0, geomJ); // geom0.intersection(geomJ);
					if (intersection.getGeometryType() === 'Point' && intersection.getCoordinates().length === 1) {
						const intersectPointJsts = intersection.getCoordinates()[0];
						const coords0 = geom0.getCoordinates();
						const coordsJ = geomJ.getCoordinates();						
						const onEndOfLine = (intersectPointJsts.equals(coords0[0]) || intersectPointJsts.equals(coords0[coords0.length - 1])) && (intersectPointJsts.equals(coordsJ[0]) || intersectPointJsts.equals(coordsJ[coordsJ.length - 1]));
						if (onEndOfLine) {
							continue;
						}
					}
					setCrossBoneAttr(arr[0]);
					setCrossBoneAttr(arr[j]);
					arr.splice(j, 1);
					break;
				}
			}
			arr.splice(0, 1);
			check(arr);
		}
		check(feats.map(f => f));
	}


	getQrInterlayerFishboneInteractiveBySsap(customerId, gadIds: string[], model?: ModelMenuItemKey) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/qrInterlayerFishboneInteractiveBySsap';
			const params: any = {
				customerId: customerId,
				ssapGadIds: JSON.stringify(gadIds)
			};
			this.requestService.requestGet(url, {
				params: params
			}, (rsp) => {
				debugger
				resolve(rsp);
			}, err => reject(err));
		});
	}
}
